export default function initYoutubePlayer() {
  function loadYouTubeAPI() {
		const tag = document.createElement('script');
		tag.src = 'https://www.youtube.com/iframe_api';
		const firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}

	function initializeYouTubePlayers() {
		const players = document.querySelectorAll('.player');

		players.forEach(playerItem => {
			const url = playerItem.dataset.url;
			const videoId = url.split('/').pop().split('?')[0];

			const player = new YT.Player(playerItem, {
				videoId: videoId,
				playerVars: {
					controls: 0,
					autoplay: 1,
					mute: 1
				},
				events: {
					'onReady': onPlayerReady,
					'onStateChange': onPlayerStateChange
				}
			});

			function onPlayerReady(event) {
				event.target.playVideo();
				const iframe = event.target.g;

				if (iframe && iframe.closest('.hero-section')) {
						iframe.setAttribute('tabindex', '-1');
				}
			}

			function onPlayerStateChange(event) {
				if (event.data == YT.PlayerState.ENDED) {
					event.target.playVideo();
				}
			}
		});
	}

	window.onYouTubeIframeAPIReady = initializeYouTubePlayers;

	loadYouTubeAPI();
}
